import React from 'react';
import PaymentCollectionTaskPanel, {
  PaymentLinkTaskDetails,
} from './PaymentCollectionTaskPanel';

/** Mirrors `HotelPaymentTaskDetails` in @dreamai/types (api/human-tasks.ts). */
export interface HotelPaymentTaskDetails extends PaymentLinkTaskDetails {
  kind: 'hotel_payment';
  hotelName: string;
  roomName: string;
  board: string;
  cancellationTerms: string;
  checkInDate: string;
  checkOutDate: string;
  guestName: string;
}

interface HotelPaymentTaskPanelProps {
  taskId: string;
  details: HotelPaymentTaskDetails;
  status: string;
  readOnly?: boolean;
  onClosed?: () => void;
}

function formatStay(checkIn: string, checkOut: string): string {
  const fmt = (iso: string) => {
    const d = new Date(`${iso}T00:00:00Z`);
    return Number.isNaN(d.getTime())
      ? iso
      : d.toLocaleDateString('en-GB', {
          weekday: 'short',
          day: 'numeric',
          month: 'short',
          year: 'numeric',
          timeZone: 'UTC',
        });
  };
  return `${fmt(checkIn)} → ${fmt(checkOut)}`;
}

/** Ops panel for a `hotel_payment` task; see PaymentCollectionTaskPanel. */
const HotelPaymentTaskPanel: React.FC<HotelPaymentTaskPanelProps> = ({
  taskId,
  details,
  status,
  readOnly = false,
  onClosed,
}) => (
  <PaymentCollectionTaskPanel
    taskId={taskId}
    details={details}
    status={status}
    booksWhat='the hotel'
    testId='hotel-payment-panel'
    readOnly={readOnly}
    onClosed={onClosed}
  >
    <div className='detail-row'>
      <span className='detail-label'>Hotel:</span>
      <span className='detail-value'>{details.hotelName}</span>
    </div>
    <div className='detail-row'>
      <span className='detail-label'>Room:</span>
      <span className='detail-value'>
        {details.roomName} — {details.board}
      </span>
    </div>
    <div className='detail-row'>
      <span className='detail-label'>Stay:</span>
      <span className='detail-value'>
        {formatStay(details.checkInDate, details.checkOutDate)}
      </span>
    </div>
    <div className='detail-row'>
      <span className='detail-label'>Guest:</span>
      <span className='detail-value'>{details.guestName}</span>
    </div>
    <div className='detail-row'>
      <span className='detail-label'>Cancellation:</span>
      <span className='detail-value'>{details.cancellationTerms}</span>
    </div>
  </PaymentCollectionTaskPanel>
);

export default HotelPaymentTaskPanel;
